// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function fetchOverpayments({ options }, props, toCSV = false) {
  return { type: types.OVERPAYMENTS_FETCH_BEGIN, options, toCSV }
}
